import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, ProtectedRoute } from "./lib/auth";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import StoresList from "./pages/StoresList";
import StoreForm from "./pages/StoreForm";
import StoreFiles from "./pages/StoreFiles";
import DataAnalysis from "./pages/DataAnalysis";
import ConvertersList from "./pages/ConvertersList";
import ConverterForm from "./pages/ConverterForm";
import ConverterLogs, { ConverterLogsRedirect } from "./pages/ConverterLogs";
import MissingSalesRadar from "./pages/MissingSalesRadar";
import MissingSalesLog from "./pages/MissingSalesLog";
import UsersList from "./pages/UsersList";
import UserForm from "./pages/UserForm";
import EmailConfigPage from "./pages/EmailConfigPage";
import ErrorLog from "./pages/ErrorLog";
import StoreClosedDays from "./pages/StoreClosedDays";
import "./App.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="stores" element={<StoresList />} />
            <Route
              path="stores/new"
              element={
                <ProtectedRoute adminOnly>
                  <StoreForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="stores/:id/edit"
              element={
                <ProtectedRoute adminOnly>
                  <StoreForm />
                </ProtectedRoute>
              }
            />
            <Route path="stores/:id/files" element={<StoreFiles />} />
            <Route path="stores/:id/data-analysis" element={<DataAnalysis />} />
            <Route path="missing-sales/radar" element={<MissingSalesRadar />} />
            <Route path="missing-sales/log" element={<MissingSalesLog />} />
            <Route path="converters" element={<ConvertersList />} />
            <Route path="converters/:id" element={<ConverterLogsRedirect />} />
            <Route path="converters/:id/input-log" element={<ConverterLogs logType="input" />} />
            <Route path="converters/:id/output-log" element={<ConverterLogs logType="output" />} />
            <Route
              path="converters/new"
              element={
                <ProtectedRoute adminOnly>
                  <ConverterForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="converters/:id/edit"
              element={
                <ProtectedRoute adminOnly>
                  <ConverterForm />
                </ProtectedRoute>
              }
            />
            <Route path="errors" element={<ErrorLog />} />
            <Route
              path="store-closed-days"
              element={
                <ProtectedRoute adminOnly>
                  <StoreClosedDays />
                </ProtectedRoute>
              }
            />
            <Route
              path="users"
              element={
                <ProtectedRoute adminOnly>
                  <UsersList />
                </ProtectedRoute>
              }
            />
            <Route
              path="users/new"
              element={
                <ProtectedRoute adminOnly>
                  <UserForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="users/:id/edit"
              element={
                <ProtectedRoute adminOnly>
                  <UserForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="email-config"
              element={
                <ProtectedRoute adminOnly>
                  <EmailConfigPage />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
